import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { ActivityListPayload, ActivityListResponse } from './report-activity-info.types';

// deprecated service ref.: getReportActivitiesService_DEPRECATED

// implementado ✅
const getModifiedEventTypeId = (eventTypeId?: string | number): string | undefined => {
  if (!eventTypeId) return undefined;
  const idStr = eventTypeId.toString();
  if (idStr === '15') return '14,15';
  if (idStr === '33' || idStr === '2') return '2,33';
  return idStr;
};

export async function listActivityReportService({ query: rawQuery }: ActivityListPayload) {
  const modifiedQuery = {
    ...rawQuery,
    event_type_id: getModifiedEventTypeId(rawQuery.event_type_id),
  };

  const query = transformIntoQueryParamString(modifiedQuery);

  const { response, data } = await BACKEND.get<ActivityListResponse>(ENDPOINT.REPORT_ACTIVITY, { query });

  return {
    response,
    summary: data,
  };
}
